export const initialPMFilters = [
    {
        filterGrupName: 'Status',
        field: 'status',
        filters: [
            {
                filterName: 'Received',
                checked: false,
            },
            {
                filterName: 'Scheduled',
                checked: false,
            },
            {
                filterName: 'PM In Progress',
                checked: false,
            },
            {
                filterName: 'Rescheduled',
                checked: false,
            },
            {
                filterName: 'PM Back In Progress',
                checked: false,
            },
            {
                filterName: 'Awaiting PO',
                checked: false,
            },
            {
                filterName: 'Canceled',
                checked: false,
            },
            {
                filterName: 'PM Completed',
                checked: false,
            },
        ],
    },
]
